<template>
  <div class="full-item flex flex-direction align-center">
    <el-form
      ref="userInfoForm"
      :model="User.user_info"
      :rules="userInfoRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '120px'"
      style="width: 90%;"
    >
      <el-form-item label="免冠头像" prop="avatar">
        <MediaUpload
          ref="avatar"
          :action="uploadUrl + '/upload/avatar'"
          :suffixList="['.png', '.jpg']"
          :file="User.user_info.avatar"
          @success="handlerUploadSuccess('avatar')"
        ></MediaUpload>
        <div class="flex text-gray" v-if="!User.user_info.avatar">
          <span>最佳尺寸:106x150px(小一寸)</span>
        </div>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          placeholder="请输入姓名"
          clearable
          v-model="User.user_info.name"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="User.user_info.sex">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="籍贯" prop="native_place">
        <el-cascader
          v-model="User.user_info.native_place"
          :options="cityOptions"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="民族" prop="nation">
        <el-select
          filterable
          v-model="User.user_info.nation"
          placeholder="请选择"
        >
          <el-option
            :label="item.label"
            :value="item.label"
            v-for="(item, index) in nationList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="手机号码" prop="mobile">
        <el-input
          placeholder="请输入手机号码"
          clearable
          v-model="User.user_info.mobile"
        ></el-input>
      </el-form-item>

      <el-form-item label="证件类型" prop="identifier_type">
        <el-select
          v-model="User.user_info.identifier_type"
          placeholder="请选择"
        >
          <el-option label="身份证" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="证件号码" prop="identifier_code">
        <el-input
          placeholder="请输入证件号码"
          clearable
          v-model="User.user_info.identifier_code"
          @input="getBirthday()"
        ></el-input>
      </el-form-item>

      <el-form-item label="出生日期" prop="birthday">
        <el-date-picker
          disabled
          value-format="yyyy-MM-dd"
          v-model="User.user_info.birthday"
          type="date"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input
          placeholder="请输入邮箱"
          clearable
          v-model="User.user_info.email"
        ></el-input>
      </el-form-item>

      <el-form-item label="通讯地址" prop="address">
        <el-input
          placeholder="请输入通讯地址"
          clearable
          v-model="User.user_info.address"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="裁判培训等级"
        prop="referee_level"
        v-if="User.user.role == $roleConsts.TECH_OFFICER.value"
      >
        <el-select v-model="User.user_info.referee_level" placeholder="请选择">
          <el-option label="国际级" value="国际级"></el-option>
          <el-option label="洲际级" value="洲际级"></el-option>
          <el-option label="国家级" value="国家级"></el-option>
          <el-option label="一级" value="一级"></el-option>
          <el-option label="二级" value="二级"></el-option>
          <el-option label="无" value="无"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="赛事履历"
        prop="referee_resume"
        v-if="User.user.role == $roleConsts.TECH_OFFICER.value"
      >
        <el-input
          placeholder="请输入赛事履历"
          clearable
          type="textarea"
          :rows="5"
          v-model="User.user_info.referee_resume"
        ></el-input>
      </el-form-item>

      <el-form-item label="签字" prop="sign">
        <vue-esign
          v-if="editSign || !User.user_info.sign"
          style="border: 1px solid #DCDFE6;"
          ref="esign"
          :height="300"
          :isCrop="false"
          :lineWidth="6"
          lineColor="#000000"
        />
        <el-button
          v-if="editSign || !User.user_info.sign"
          type="primary"
          size="mini"
          @click="resetEsign"
        >
          重置
        </el-button>

        <el-button v-else type="primary" size="mini" @click="editSign = true">
          修改签字
        </el-button>
        <img style="width: 100%;":src="User.user_info.sign" v-if="User.user_info.sign"></img>
      </el-form-item>
    </el-form>

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="submit()"
    >
      确认提交
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mobileRegex, emailRegex, idCardRegex } from '@/utils/reConsts.js';
import { baseUrl } from '@/utils/consts.js';
import { showErrorMsg, showSuccessMsg } from '@/utils/uiUtils.js';
import { submitUserInfo } from '@/servers/user.js';
import citys from '@/utils/city.js';
import nationList from '@/utils/nation.js';
import MediaUpload from '@/components/upload/mediaUpload.vue';

export default {
  components: {
    MediaUpload,
  },

  data() {
    let validateMobile = (_, value, callback) => {
      if (!mobileRegex.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    let validateEmail = (_, value, callback) => {
      if (!emailRegex.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    };

    let validateIdCard = (_, value, callback) => {
      if (!idCardRegex.test(value)) {
        callback(new Error('请输入正确的身份证号码'));
      } else {
        callback();
      }
    };

    return {
      editSign: false,
      cityOptions: citys,
      nationList: nationList,
      uploadUrl: baseUrl,
      userInfoRules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        avatar: [
          {
            required: true,
            message: '请上传免冠头像',
            trigger: 'blur',
          },
        ],
        sex: [
          {
            required: true,
            message: '请输入性别',
            trigger: 'blur',
          },
        ],
        native_place: [
          {
            required: true,
            message: '请输入籍贯',
            trigger: 'blur',
          },
        ],
        nation: [
          {
            required: true,
            message: '请输入民族',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机',
            trigger: 'blur',
          },
          {
            validator: validateMobile,
            trigger: 'blur',
          },
        ],
        identifier_type: [
          {
            required: true,
            message: '请输入证件类型',
            trigger: 'blur',
          },
        ],
        identifier_code: [
          {
            required: true,
            message: '请输入证件号码',
            trigger: 'blur',
          },
          {
            validator: validateIdCard,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur',
          },
          {
            validator: emailRegex,
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入通讯地址',
            trigger: 'blur',
          },
        ],
        referee_level: [
          {
            required: true,
            message: '请选择裁判等级',
            trigger: 'blur',
          },
        ]
      },
    };
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    ...mapMutations(['getUserState']),

    resetEsign: function() {
      this.$refs.esign.reset();
    },

    handlerUploadSuccess: function(key) {
      this.User.user_info[key] = this.$refs[key].uploadRes;
    },

    getBirthday: function() {
      if (idCardRegex.test(this.User.user_info.identifier_code)) {
        this.User.user_info.birthday =
          this.User.user_info.identifier_code.substring(6, 10) +
          '-' +
          this.User.user_info.identifier_code.substring(10, 12) +
          '-' +
          this.User.user_info.identifier_code.substring(12, 14);
      }
    },

    submit: function() {
      let that = this;
      this.$refs.userInfoForm.validate((valid) => {
        if (valid) {
          if (this.editSign || !this.User.user_info.sign) {
            this.$refs.esign
              .generate()
              .then((res) => {
                this.User.user_info.sign = res;
                console.log(res); // base64图片
                submitUserInfo(this.User.user_info, function(res) {
                  showSuccessMsg(res);
                  that.getUserState();
                  that.$router.replace({
                    name: 'info',
                  });
                });
              })
              .catch((err) => {
                submitUserInfo(this.User.user_info, function(res) {
                  showSuccessMsg(res);
                  that.getUserState();
                  that.$router.replace({
                    name: 'info',
                  });
                });
              });
          } else {
            submitUserInfo(this.User.user_info, function(res) {
              showSuccessMsg(res);
              that.getUserState();
              that.$router.replace({
                name: 'info',
              });
            });
          }
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/userInfoApprove/userInfo.vue